"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_view_1 = __importDefault(require("./index.view"));
function UsersTableSection() {
    return react_1.default.createElement(index_view_1.default, null);
}
exports.default = UsersTableSection;
